<template>
  <div class="c-feedback-box">
    <h3 class="c-feedback-box__title">{{ $t('FEEDBACK_TITLE') }}</h3>
    <form class="c-feedback-box__form"
      :class="formSuccess ? 'c-feedback-box__form--sent' : ''"
      name="feedback"
      @submit="sendFeedback">

      <p v-if="formSuccess">{{ $t('FEEDBACK_THANK_YOU') }}</p>

      <span>
        <ul>
          <li v-for="(error, i) in errors"
            :key="i"
            >{{ error }}</li>
        </ul>
      </span>

      <label class="c-feedback__label">
        {{ $t('FEEDBACK_TEXT') }}
        <textarea
          name="text"
          v-model="feedback.text"
          class="c-feedback__textarea" />  
      </label>

      <div>
        <FHButton class="c-feedback__btn"
          nativeType="submit">
          {{ $t('FEEDBACK_SUBMIT') }}
        </FHButton>
      </div>
    </form>
    <div
      class="c-feedback__cross-button"
      v-shortkey="['esc']"
      @shortkey="$emit('close-feedback')"
      @keydown.enter="$emit('close-feedback')"
      @click="$emit('close-feedback')"
      tabindex="0">
      <span
        class="c-feedback__cross-button-cross">
      </span>
      <span
        class="c-feedback__cross-button-cross">
      </span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import FHButton from '@forlagshuset/v-button'

export default {
  components:{
    FHButton
  },

  computed: {
    ...mapState('user', {
      user: state => state.user
    })
  },

  data() {
    return {
      errors: [],
      formSuccess: false,
      feedback: {
        text: '',
        email: '',
      }
    }
  },

  methods: {
    sendFeedback (e) {
      e.preventDefault()
      this.formSuccess = false
      this.errors = []

      if (this.feedback.text === '') {
        this.errors.push(this.$t('FEEDBACK_TEXT_REQUIRED'))
      }

      if (this.errors.length === 0) {
        this.formSuccess = true
        return true
      }

      return false
    },

    validEmail (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  },

}
</script>

<style scoped lang="scss">
@import '@/assets/scss/_vars.scss';
@import '@/assets/scss/_mixin.scss';

.c-feedback-box {
  position: fixed;
  top: 5em;
  left: 30%;
  width: 40%;
  background: $white;
  z-index: 99999;
}
.c-feedback-box__title {
  padding: 1em 3em 1em 1em;
  background: $light-blue;
  color: $white;
  margin: 0;;
}
.c-feedback-box__form {
  padding: 0em 2em 2em;
}
.c-feedback__label,
.c-feedback__input,
.c-feedback__textarea {
  display: block;
  width: 100%;
  margin: .5em 0;
}
.c-feedback__textarea {
  height: 5rem;
}
.c-feedback__checkbox + .c-feedback__label {
  width: auto;
  display: inline;
}
.c-feedback__cross-button {
  position: absolute;
  right: .75em;
  top: 1em;

  width: 1.5em;
  height: 1.5em;

  &:focus {
    @include a11yOutline();
  }
}
.c-feedback__cross-button-cross {
  position: absolute;
  transform: rotate(45deg);

  width: 1px;
  height: 25px;

  background-color: $white;
  color: $white;
  border: 2px solid $white;
  margin-left: 10px;
  cursor: pointer;
}
.c-feedback__cross-button-cross:last-child {
  transform: rotate(-45deg);
}
.c-feedback__btn {
  @include btnReset();
}
</style>
